import React from "react";
import { useTranslation } from "react-i18next";
import { Form, ModalBuilder } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { amendExpiryDate } from "../actions";
import { DropdownItem } from "semantic-ui-react";
import { NonPropagatingDate } from "features/../../../shared/components/forms/NonPropagatingField";

const AmendExpiryDate = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, expiryDate } = sheet;

  return (
    <ModalBuilder
      withForm
      initialData={{ expiryDate }}
      submitAction={amendExpiryDate}
      submitParams={{ sheetId }}
      onSubmitted={onSubmitted}
      renderError={false}
      renderSubmitting={false}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>
          {t("SheetActions.AmendExpiry.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Edit
          {...modalProps}
          header={t("SheetActions.AmendExpiry.HeaderText")}
        >
          <Form {...formProps}>
            <div className="flex">
              <NonPropagatingDate
                local
                field="expiryDate"
                label={t("SheetActions.AmendExpiry.ExpiryDate_Label")}
                width={25}
                dateFormat="DD MMM yyyy"
              />
            </div>
          </Form>
        </TranslatedModal.Edit>
      )}
    />
  );
};

export default AmendExpiryDate;
